<template>
  <div>
    <v-container class="text-left">
      <v-row class="my-md-10 my-3">
        <v-col cols="12"><h1 class="text-center red--text text--darken-2">Contact</h1></v-col>
        <v-col cols="12" class="col-sm-12 col-md-4">
          <!-- <v-row>
            <v-col> -->
              <h3>Openingstijden</h3>
            <!-- </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="8" class="col-sm-8 col-md-6">
              Maandag t/m Vrijdag<br>
              Zaterdag<br>
              Zondag<br>
            </v-col>
            <v-col cols="4" class="col-sm-4 col-md-6">
              9:30-17:00<br>
              9:30-12:00<br>
              Gesloten<br>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
            <b>Wij werken bij voorkeur op afspraak, maar binnenlopen kan ook.</b>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-3 offset-md-1">
          <h3>Contact informatie</h3>
          Aletta Jacobsstraat 304<br>
          2614 JD  DELFT<br><br>
          015-256 01 12<br>
          <!-- 06-36 56 5789<br> -->
          06-43 02 6707<br>
          info@bikangtang.nl<br>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-3 offset-md-1">
          <v-row>
            <v-col>
              <h3>Informatie</h3>
              AGB code praktijk 90-062796<br>
              AGB code zorgverlener 90-103433<br>
              KVK: 84280840<br>
              BTW- ID: 851958825B01<br>
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col cols="6">
              <v-img
                alt="Vuetify Logo"
                class="shrink mr-2 white"
                contain
                src="./assets/img/logo-VBAG.jpeg"
                transition="scale-transition"
              />
            </v-col>
            <v-col class="my-3 white" cols="6">
              <v-img
                alt="Vuetify Logo"
                class="shrink mr-2 white"
                contain
                src="./assets/img/rbcz-logo.png"
                transition="scale-transition"
              />
            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
      <v-row class="my-10">
        <v-col cols="12"><h1 class="text-center red--text text--darken-2">Locatie</h1></v-col>
        <v-col cols="12" class="col-sm-12 col-md-6 mt-md-10">
          <!-- <p>Wij werken bij voorkeur op afspraak, maar binnenlopen kan ook.</p> -->

          <h3>Per auto</h3>
          <p>Bij ons kunt u onbetaald parkeren. Er is voldoende parkeerplaats voor de deur van Bi Kang Tang.</p>

          <h3>Openbaar vervoer</h3>
          <p>Bus 32, 37 en 38 halte Componistenpad. Vanaf deze halte is het ongeveer 5 minuten lopen.</p>
          <p>Bus 82 halte Westlandhof. Vanaf deze halte is het ongeveer 1 minuut lopen.</p>
        </v-col>
        <v-col cols="12" class="col-sm-12 col-md-6">
          <v-img
            alt="Google Maps kaart van locatie Bi Kang Tang"
            class="shrink"
            cover
            min-width="100"
            src="@/assets/img/maps.png"
            height="100%"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>